<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>标题：</p>
          <input type="text" placeholder="请输入标题" v-model="obj.title">
        </div>
        <div class="search-item">
          <p>排序：</p>
          <select v-model="obj.sort">
            <option value="asc">升序</option>
            <option value="desc">降序</option>
          </select>
        </div>
        <div class="search-item">
          <p>状态：</p>
          <select v-model="obj.status">
            <option :value="item.id" v-for="item in statusList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="search-item">
          <p>创建时间：</p>
          <select v-model="obj.create_time">
            <option value="asc">升序</option>
            <option value="desc">降序</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>会员列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加banner</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.img">
                <img :src="'https://pic.bi-rong.com/'+item.img" alt="">
              </p>
              <p :title="item.type==1?'首页':item.type==2?'练习页':item.type==3?'会员中心页':''">
                {{item.type==1?'首页':item.type==2?'练习页':item.type==3?'会员中心页':''}}
              </p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.status?'开启':'未开启'">
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543;">
                  <span @click="editShow(item)">编辑</span>
                  <span @click="removeSub(item)">删除</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加类型':'编辑类型'}}</p>
        <form>
          <div class="write-txt">
            <p>标题：</p>
            <input type="text" v-model="addObj.title">
          </div>
          <div class="write-txt">
            <p>上传图片</p>
            <div class="upload">
              <div class="img" @mouseenter="imgShow('ExerSet')" @mouseleave="imgHide('ExerSet')">
                  <img :src="'https://pic.bi-rong.com/'+addObj.img" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="el-icon-delete" @click="imgRemove('ExerSet')"></i>
                  </div>
                </div>
              <el-upload
                :action="'https://upload.qiniup.com'"
                :data="uploadObj" 
                list-type="picture-card"
                :before-upload="beforeUploadImg"
                :on-success="handleSuccessImg"
                :on-progress="handleProgressImg"
                :on-remove="handleRemoveImg">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="'https://pic.bi-rong.com/'+addObj.img" alt="">
              </el-dialog>
            </div>
          </div>
          <div class="write-txt">
            <p>上传pad端图片</p>
            <div class="upload">
              <div class="img" @mouseenter="imgShow('ExerSet')" @mouseleave="imgHide('ExerSet')">
                  <img :src="'https://pic.bi-rong.com/'+addObj.pad_img" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="el-icon-delete" @click="imgRemove('ExerSet')"></i>
                  </div>
                </div>
              <el-upload
                :action="'https://upload.qiniup.com'"
                :data="uploadObj" 
                list-type="picture-card"
                :before-upload="beforeUploadPadImg"
                :on-success="handleSuccessPadImg"
                :on-progress="handleProgressImg"
                :on-remove="handleRemovePadImg">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="'https://pic.bi-rong.com/'+addObj.pad_img" alt="">
              </el-dialog>
            </div>
          </div>
          <div class="write-txt">
            <p>显示位置：</p>
            <select v-model="addObj.type">
              <option value="">请选择</option>
              <option value="1">首页</option>
              <option value="2">练习页</option>
              <option value="3">会员中心页</option>
            </select>
          </div>
          <div class="write-txt">
            <p>排序：</p>
            <input type="text" v-model="addObj.sort">
          </div>
          
          
          <div class="write-txt">
            <p>状态：</p>
            <el-radio-group v-model="addObj.status">
              <el-radio label="1">显示</el-radio>
              <el-radio label="0">隐藏</el-radio>
            </el-radio-group>
          </div>
          <div class="write-txt">
            <p>ios跳转页面：</p>
            <input type="text" v-model="addObj.ios_controller">
          </div>
          <div class="write-txt">
            <p>Android跳转页面：</p>
            <input type="text" v-model="addObj.android_controller">
          </div>
          <div class="write-txt">
            <p>URL跳转页面：</p>
            <input type="text" v-model="addObj.url">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getBannerList,saveBanner,getUploadToken,saveBannerStatus,delBanner } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'7',
      childrenID:'7-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'标题'},
        {id:3,title:'banner图片'},
        {id:4,title:'显示位置'},
        {id:5,title:'排序'},
        {id:6,title:'状态'},
        {id:8,title:'创建时间'},
        {id:9,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        status:9,
        sort:'asc',
        create_time:'asc'
      },
      addObj:{
        title:'',
        img:'',
        pad_img:'',
        type:'',
        sort:'',
        url:'',
        ios_controller:'',
        android_controller:'',
        status:false,
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      statusList:[
        {id:9,title:'全部'},
        {id:1,title:'开启'},
        {id:0,title:'未开启'},
      ],
      testList:[],
      uploadObj:{
        token:'',
        key:'',
      },
      uploadUrl:'',
      loadTxt:'',
      dialogVisible:false,
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      this.addObj={
        title:'',
        img:'',
        pad_img:'',
        type:'',
        sort:'',
        url:'',
        ios_controller:'',
        android_controller:'',
        status:false,
      };
      this.showType = '';
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入标题');
        return false;
      } else if(this.addObj.img == ''){
        that.$message('请选择图片');
        return false;
      } else if(this.addObj.pad_img == ''){
        that.$message('请选择pad图片');
        return false;
      } else if(this.addObj.type == ''){
        that.$message('请选择显示位置');
        return false;
      } else if(this.addObj.sort == ''){
        that.$message('请选择排序');
        return false;
      }
      // else if(this.addObj.ios_controller == ''){
      //   that.$message('请输入ios跳转地址');
      //   return false;
      // } else if(this.addObj.android_controller == ''){
      //   that.$message('请输入android跳转地址');
      //   return false;
      // } else if(this.addObj.url == ''){
      //   that.$message('请输入url地址');
      //   return false;
      // }
      saveBanner(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.addObj={
        title:'',
        img:'',
        pad_img:'',
        type:'',
        sort:'',
        url:'',
        ios_controller:'',
        android_controller:'',
        status:false,
      };
      this.obj = {
        page:1,
        rows:10,
        status:9,
        sort:'asc',
        create_time:'asc'
      }
      this.dataList = [];
      this.getList();
      
    },

    getToken(){
      getUploadToken(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          this.uploadObj.token = data.data.token
        }
      })
    },

    beforeUploadImg(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    beforeUploadPadImg(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    handleSuccessImg(response, file, fileList){
      this.addObj.img = response.key;
      this.loading = false;
      this.uploadObj.key = '';
      this.imgType = false;
    },
    handleSuccessPadImg(response, file, fileList){
      this.addObj.pad_img = response.key;
      this.loading = false;
      this.uploadObj.key = '';
      this.imgType = false;
    },
    
    handleSuccess(response, file, fileList){
      console.log(response)
      this.uploadUrl = response.data.src;
      this.loading = false;
    },
    handleProgressImg(event, file, fileList) {
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
    },
   
    handleRemoveImg(){
      this.uploadUrl = '';
      this.addObj.img = '';
    },
    handleRemovePadImg(){
      this.uploadUrl = '';
      this.addObj.pad_img = '';
    },

    getList(){
      var that = this;
      getBannerList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          data.data.list.forEach(function(item,index){
            console.log(item.status)
            if(item.status = 0){
              item.status = false
            } else {
              item.status = true
            }
          })
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
    },

    editShow(e){
      var that = this;
      this.addObj.id = e.id;
      this.addObj.title = e.title;
      this.addObj.img = e.img;
      this.addObj.pad_img = e.pad_img;
      this.addObj.type = e.type;
      this.addObj.sort = e.sort;
      this.addObj.status = e.status ? '1' : '0';
      this.addObj.url = e.url;
      this.addObj.ios_controller = e.ios_controller;
      this.addObj.android_controller = e.android_controller;
      this.imgType = true;
      this.showType = 'edit';
      
      console.log(this.addObj,'==obj==')
    },

    removeSub(e){
      var that = this;
      delBanner({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
      
    }, 

    switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        status:e.status==false?0:1,
        sort:e.sort
      };
      saveBannerStatus(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    topicSub(e){
      var that = this;
      console.log(e.mtid)
      that.$router.push('/pack?id='+e.mtid);
    },

    lookStudent(e){
      var that = this;
      that.$router.push('/parent');
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 8 );
}

.dataList .listItem p img{
  width: 100%;
}

.el-switch,
.el-radio-group{
  height: 36px;
  width: 225px;
}

.el-radio{
  line-height: 36px;
}

.el-radio__label{
  font-size: 15px;
}

.write-txt .upload{
  display: inline-block;
  width: 225px;
  vertical-align: top;
}
.tipsBox form .write-txt p{
  width: 200px;
}
.write-txt .upload .img img{
  width: 100%;
}
.tipsBox .contv{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/market/list.vue